import {Injectable} from '@angular/core';
import {IAppConfig} from '../models/appConfig/iapp-config';

@Injectable()
export class UiConfigServiceMock {

  public settings: IAppConfig;

  constructor() {
    this.settings = {
      host_antragserfassung: {
        url_dmz_auth: 'DMZAuth',
        url_dmz_anon: 'DMZAnon',
        url_lan_auth: 'LanAuth',
        url_lan_anon: 'LanAnon'
      }
    } as IAppConfig;
  }

  public getAntragserfassungUrl(): string {
    return 'antragserfassungUrlMock';
  }
}
